<template>
    <ul class="divide-y w-full">
        <slot />
    </ul>
</template>
